// extracted by mini-css-extract-plugin
module.exports = {"button":"PaymodeBtn_button__3o_mg","label":"PaymodeBtn_label__3iUDz","imageContainer":"PaymodeBtn_imageContainer__1FgQ-"};